import styled, { css } from 'styled-components';

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  font-weight: 900;
  box-sizing: border-box;
  ${({ color, bgColor }) => css`
    background-color: ${bgColor};
    color: ${color};
  `}
`;

export const ConnectionStatus = styled.div`
  display: flex;
  width: 250px;
  height: 48px;
  border: 1px solid gray;
  border-radius: 3px;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  & i {
    padding-right: 5px;
  }
  ${({ hover, bgColor, color }) => css`
    background-color: ${bgColor};
    color: ${color};
    ${hover &&
    css`
      :hover {
        cursor: pointer;
      `}
  `}
`;

export default ConnectionStatus;
